import {
  CartContextProvider,
  LeisureConfirmationStep,
  LeisurePaymentStep,
  LeisurePurchasePage,
  LeisurePurchaseProvider,
  LeisureShippingStep,
  LeisureSummaryStep,
  LeisureValidationStep
} from 'components';
import { ProtectedRoute } from 'router';

export const leisurePurchaseRoutes = {
  leisurePurchase: {
    path: '/achat-loisirs',
    component: () => (
      <ProtectedRoute>
        <CartContextProvider>
          <LeisurePurchaseProvider>
            <LeisurePurchasePage />
          </LeisurePurchaseProvider>
        </CartContextProvider>
      </ProtectedRoute>
    ),
    children: {
      summary: {
        path: '/achat-loisirs/recapitulatif',
        component: () => (
          <ProtectedRoute>
            <LeisureSummaryStep />
          </ProtectedRoute>
        )
      },
      shipping: {
        path: '/achat-loisirs/livraison',
        component: () => (
          <ProtectedRoute>
            <LeisureShippingStep />
          </ProtectedRoute>
        )
      },
      validation: {
        path: '/achat-loisirs/validation',
        component: () => (
          <ProtectedRoute>
            <LeisureValidationStep />
          </ProtectedRoute>
        )
      },
      payment: {
        path: '/achat-loisirs/paiement',
        component: () => (
          <ProtectedRoute>
            <LeisurePaymentStep />
          </ProtectedRoute>
        )
      },
      confirmation: {
        path: '/achat-loisirs/confirmation',
        component: () => (
          <ProtectedRoute>
            <LeisureConfirmationStep />
          </ProtectedRoute>
        )
      }
    }
  }
};
